import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { ICON } from "../lib";
import PropTypes from "prop-types";

function Icon({ name, ...props }) {
  return (
    <SvgIcon aria-label={`ícone para ${name}`} {...props}>
      <path d={`${ICON[name]}`} />
    </SvgIcon>
  );
}

Icon.propTypes = {
  name: PropTypes.oneOf(["nurse", "pharmacy"]).isRequired,
};

export default Icon;
